module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/travelcost/travelcost.component.scss
// module id = ./client/app/travelcost/travelcost.component.scss
// module chunks = main